import { lazy } from 'react';

const SettingsPage = lazy(() => import('./pages/SettingsPage'));

export const SettingsEntry = () => <SettingsPage />;
